module.exports = __webpack_public_path__ + "static/media/font-logo-dev.b5b972f8.svg";